import { Form } from "antd";
import * as React from "react";
import { ZodUnion } from "zod";
import { $ZodType } from "zod/v4/core";

import { FieldDef, itemName, makeLabel } from "../attrMetaEditorUtils";
import { InputNumberOrString } from "./InputNumberOrString";

type PropsAttrMetaViewWidth = {
  node: $ZodType;
  path: string[];
  field?: FieldDef;
};

export const AttrMetaViewWidth: React.FC<PropsAttrMetaViewWidth> = (props) => {
  const { node, path, field } = props;
  const label =
    node instanceof ZodUnion ? makeLabel(node, path, field) : "Ширина";
  return (
    <Form.Item name={itemName(path)} label={label}>
      <InputNumberOrString allowClear title={path.join(".")} />
    </Form.Item>
  );
};
